module.exports = __webpack_public_path__ + "img/shouji.bab44f65.png";